var o=function(o){return o[o.IsLoading=0]="IsLoading",o[o.NotLoading=1]="NotLoading",o}({});export{o as Loading};
//# sourceMappingURL=ActionButtonModel.js.map
